import { FormDialog } from "../../components/FormDialog/FormDialog";

const CoreDocumentsDialog = ({ formId, readOnly, saveCoreDocumentsData, coreDocumentsSchema, uiSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            schema={coreDocumentsSchema}
            uiSchema={uiSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveCoreDocumentsData}
        />
    );
}

export default CoreDocumentsDialog;
